import React from 'react';
import { avatarColorCache } from '../../utils/avatarColorCache';

interface UserAvatarProps {
  firstName?: string;
  lastName?: string;
  email?: string; // Добавляем email для генерации цвета
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * User Avatar Component for header display
 * Показывает инициалы пользователя в кружке
 */
export function UserAvatar({ 
  firstName, 
  lastName, 
  email,
  size = 'md',
  className = '' 
}: UserAvatarProps) {
  
  // Генерируем инициалы из имени и фамилии
  const getInitials = () => {
    // Если есть имя/фамилия — используем их
    if (firstName || lastName) {
      const first = (firstName || 'U')[0];
      const last = (lastName || 'S')[0];
      return `${first}${last}`.toUpperCase();
    }
    // Если имени нет, но есть email — берём первые 2 буквы локальной части
    if (email) {
      const local = String(email).split('@')[0] || '';
      const letters = (local.match(/[A-Za-zА-Яа-я0-9]/g) || []).slice(0, 2);
      if (letters.length > 0) {
        const a = letters[0] || 'U';
        const b = letters[1] || '';
        return `${a}${b}`.toUpperCase();
      }
    }
    // Фолбэк
    return 'U';
  };

  // Размеры в зависимости от пропса size
  const sizeClasses = {
    xs: 'w-7 h-7', // 28px
    sm: 'w-8 h-8', // 32px
    md: 'w-10 h-10', // 40px
    lg: 'w-12 h-12' // 48px
  };

  const textSizes = {
    xs: 'text-[12px]', // Меньший размер текста для xs
    sm: 'text-[12px]',
    md: 'text-[14px]',
    lg: 'text-[16px]'
  };

  const initials = getInitials();

  // Получаем динамический цвет на основе email
  const avatarColor = avatarColorCache.getColor(email || '');
  
  return (
    <div
      className={`relative rounded-full shrink-0 flex items-center justify-center ${sizeClasses[size]} ${className}`}
      style={{ backgroundColor: avatarColor }}
    >
      <span className={`text-[#2b1664] font-bold leading-none ${textSizes[size]}`}>
        {initials}
      </span>
    </div>
  );
} 